import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { animate, style, transition, trigger } from '@angular/animations';
import { AutenticacaoService } from '../../services/autenticacao.service';
import { Mensagem } from 'shared/entities/mensagem.entity';
import { LoginOperador } from 'shared/entities/loginoperador.entity';
import { UsuarioConta } from 'shared/entities/usuarioconta.entity';
import { TrocaSenha } from 'shared/entities/trocasenha.entity';
import { AlertifyService } from 'shared/services/alertify.service';
import { UsuarioAutenticado } from 'shared/entities/usuarioautenticado.entity';
import { NavegacaoPaginaService } from '../../services/navegacaopagina.service';
import { PlataformaService } from '../../services/plataforma.service';
import { ParametroService } from '../../services/parametro.service';


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  animations: [
    trigger('openClosed', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('0.3s', style({ transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        animate('0.1s', style({ transform: 'translateX(-100%)' }))
      ])
    ])
  ]
})

export class ChangePasswordComponent implements OnInit {

  public Erros: Mensagem[] = [];
  public Item: TrocaSenha = new TrocaSenha();
  public DadoAutenticacao: UsuarioAutenticado = new UsuarioAutenticado();

  constructor(

    readonly router: Router,
    readonly autenticacaoSrv: AutenticacaoService,
    readonly alertify: AlertifyService,
    readonly srvNavegacao: NavegacaoPaginaService,
    readonly srvPlataforma: PlataformaService,
    private srvParametro: ParametroService
  ) {
    this.Item.IdentificadorUsuario = autenticacaoSrv.DadoAutenticacao.IdentificadorUsuario;
    this.DadoAutenticacao = autenticacaoSrv.DadoAutenticacao;

  }

  ngOnInit() {

  }

  Alterar(): void {
    this.Erros = [];
    var item: TrocaSenha = JSON.parse(JSON.stringify(this.Item));
    this.srvPlataforma.RetornarChavePublica().subscribe(async chave => {
      if (item.SenhaAtual)
      item.SenhaAtual = await this.autenticacaoSrv.encrypt(this.Item.SenhaAtual, chave);
      if (item.NovaSenha)
      item.NovaSenha = await this.autenticacaoSrv.encrypt(this.Item.NovaSenha, chave);
      if (item.ConfirmacaoSenha)
      item.ConfirmacaoSenha = await this.autenticacaoSrv.encrypt(this.Item.ConfirmacaoSenha, chave);
    this.autenticacaoSrv.AlterarSenha(item).subscribe(resultado => {

      if (resultado.Sucesso) {
        this.autenticacaoSrv.DadoAutenticacao.PrimeiroAcesso = false;

        this.srvParametro.Retornar(77).subscribe(d=>
          {
            if (d)
              this.srvNavegacao.TextoConfirmacao = d.Valor;
          })

        if (resultado.Mensagens.length > 0)
          this.alertify.sucess(resultado.Mensagens.map(f => f.Texto).join("<br/>"));
        if (!this.DadoAutenticacao.IBConfirmacao && this.srvNavegacao.TextoConfirmacao) {
          this.srvNavegacao.ConfirmarInternetBanking(true);
        }
        else
        this.router.navigate(['home']);
      }
      else
        this.Erros = resultado.Mensagens;
    });
  });
  }

  PossuiErroCampo(): boolean {
    return this.Erros && this.Erros.some(d => !d.Campo || d.Campo.length == 0);
  }

}
